import { Link, NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const linkClass = ({ isActive }) =>
  `text-xs uppercase tracking-[0.25em] transition-colors duration-300 hover:text-golddark ${
    isActive ? "text-golddark" : "text-smoke"
  }`;

export const Navbar = () => {
  const { pathname } = useLocation();
  return (
    <motion.header
      initial={{ y: -48, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-borderline/70 bg-ivory/80 backdrop-blur-md"
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-serif text-2xl italic tracking-wide text-ink transition-colors duration-300 hover:text-golddark"
        >
          kanakleaf
        </Link>
        <nav className="flex items-center gap-6 md:gap-10" data-testid="nav-links">
          <NavLink to="/" end className={linkClass} data-testid="nav-home-link">
            Home
          </NavLink>
          <NavLink to="/catalogue" className={linkClass} data-testid="nav-catalogue-link">
            Catalogue
          </NavLink>
          <Link
            to="/catalogue"
            data-testid="nav-enquire-btn"
            className="hidden rounded-full border border-gold px-5 py-2 text-xs uppercase tracking-[0.25em] text-golddark transition-all duration-500 hover:bg-gold hover:text-ivory md:inline-block"
          >
            Enquire
          </Link>
        </nav>
      </div>
      <span className="sr-only">{pathname}</span>
    </motion.header>
  );
};
